import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { isDevelopmentMode } from '../config/development'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user, token } = useAuth()
  const [hasInitialized, setHasInitialized] = useState(false)

  // Track auth state changes and initialization
  useEffect(() => {
    console.log('🔐 ProtectedRoute: Auth state changed:', {
      isAuthenticated,
      isLoading,
      hasUser: !!user,
      hasToken: !!token,
      timestamp: new Date().toISOString()
    })

    // Mark as initialized once loading is complete
    if (!isLoading) {
      setHasInitialized(true)
    }
  }, [isAuthenticated, isLoading, user, token])

  console.log('🔐 ProtectedRoute: Render #' + Date.now() + ' - Auth state:', {
    isAuthenticated,
    isLoading,
    hasUser: !!user,
    hasToken: !!token,
    timestamp: new Date().toISOString()
  })

  // Show loading spinner while checking authentication
  if (isLoading || !hasInitialized) {
    console.log('🔐 ProtectedRoute: Still loading, showing spinner')
    console.log('🔐 ProtectedRoute: Loading state:', {
      isLoading,
      hasInitialized
    })
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  // Remove development bypass: always enforce auth

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    console.log('🔐 ProtectedRoute: Not authenticated, redirecting to login')
    console.log('🔐 ProtectedRoute: Current auth state:', {
      isAuthenticated,
      isLoading,
      hasUser: !!user,
      hasToken: !!token,
      localStorageToken: !!localStorage.getItem('token'),
      localStorageUser: !!localStorage.getItem('user')
    })
    return <Navigate to="/login" replace />
  }

  console.log('🔐 ProtectedRoute: Authenticated, rendering protected content')
  return children
}

export default ProtectedRoute
